export const PACKAGE_TABS = ["overview", "previews", "details", "offer", "documents", "messages"];

export const DOCUMENT_REQUIREMENTS = ["order", "revision", "contact", "sender", "facts", "rights", "offer", "summaries", "web01", "previews"];

export function checkAction(key) {
  if (key === "order") return { order: true };
  if (["revision", "contact", "sender", "facts", "rights", "summaries"].includes(key)) return { tab: "details" };
  if (key === "offer") return { tab: "offer" };
  if (["web01", "previews"].includes(key)) return { tab: "previews" };
  return { tab: "documents" };
}

export const openPackageChecks = checks => [...DOCUMENT_REQUIREMENTS, "files", "review"].filter(key => !checks[key]);

// These labels guide the operator; only the backend can grant readiness.
export function nextPackageAction({ checks, states, dirty, archived }) {
  if (archived) return { tab: "overview", label: "Auftrag archiviert", blocked: true };
  if (dirty) return { tab: "details", label: "Angaben speichern", blocked: true };
  if (!checks.order) return { order: true, label: "Auftragsdaten ergänzen" };
  if (["revision", "contact", "sender", "facts", "rights", "summaries"].some(key => !checks[key])) return { tab: "details", label: "Kundendaten prüfen" };
  if (!checks.offer) return { tab: "offer", label: "Angebot prüfen" };
  if (!checks.previews || !checks.web01) return { tab: "previews", label: "Vorschauen prüfen" };
  if (!checks.files) return { tab: "documents", label: "Dateien erstellen und prüfen" };
  if (!checks.review) return { tab: "documents", label: "Dateien prüfen" };
  if (states.concept_package_ready) return { tab: "messages", label: "Entwürfe ansehen" };
  return { tab: "overview", label: "Prüfungen und nächste Aktion" };
}

